import { apiRequest } from "api";
import { BASE_URL } from "constants/routes";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { encryptPayload } from "./encrypt";
import { useDispatch } from "react-redux";
import { setLoading } from "redux/stepperReducer";
import {storeOrganisationIdReducer } from "redux/loggedInUserInfo";

export const getConfiguration = createAsyncThunk("fetchApi/configuration", async (id,{ dispatch }) => {
  const req = `${BASE_URL}/configuration/getConfigurationById`
  let params = {
    body: {_id: id}
  }
  const encryptedBodyRes = await encryptPayload("",params,true,true)

  // const req = `${BASE_URL}/configuration/getConfiguration/${id}`
  const options = {
    method: 'POST',
    body: JSON.stringify(encryptedBodyRes),
    headers: {
      "Content-Type": "application/json"
    },
  }
  
  try {
    const result = await encryptPayload(req, options, false, true);
    dispatch(storeOrganisationIdReducer(result.data))
    if (result?.status == "failed"){
      window.location.href = "/unified/error"
    }
    return result.data;
  }
  catch (err) {
    // console.log("🚀 ~ getConfiguration ~ err:", err)
    window.location.href = "/unified/error"
    // console.log(err)
  }
})

export const getConfigurationByName = createAsyncThunk("fetchApi/configurationByName", async (body) => {

  const req = `${BASE_URL}/configuration/getConfiguration`
  let params = {
    body: body
  }
  const encryptedBodyRes = await encryptPayload('', params, true, true);
  const options = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(encryptedBodyRes)
  }
  try {
    const result = await encryptPayload(req, options, false, true,true);

    if(result.status === "failed"){
      window.location.href = "/unified/error"
    }
    return result;
  }
  catch (err) {
    window.location.href = "/unified/error"
  }
})

export const checkLinkForExpiryBasedOnID = createAsyncThunk("fetchApi/getLinkExpiryByID", async (body) => {

  const req = `${BASE_URL}/expiry/checkLinkExpiry`
  let params = {
    body: body
  }
  const encryptedBodyRes = await encryptPayload('', params, true, true);
  const options = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(encryptedBodyRes)
  }
// // console.log(_options)
  try {
    const result = await encryptPayload(req, options, false, true,true)

    if(result.status === "failed"){
      window.location.href = "/unified/error"
    }
    return result.data;
  }
  catch (err) {
    window.location.href = "/unified/error"
    // // console.log(`err)
  }
})


export const createLinkExpiry =createAsyncThunk("fetchApi/createLinkExpiry", async (body) => {

  const req = `${BASE_URL}/expiry/createLinkExpiry`
  let params = {
    body: body
  }
  const encryptedBodyRes = await encryptPayload('', params, true, true);
  const options = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(encryptedBodyRes)
  }
// // console.log(_options)
  try {
    const result = await encryptPayload(req, options, false, true,true)
    if(result.status == "failed"){
      window.location.href = "/unified/error"
    }
    return result.data;
  }
  catch (err) {
    window.location.href = "/unified/error"
    // // console.log(`err)
  }
})